import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ModalModule } from '../modal/modal.module';
import { MobileTooltipComponent } from './mobile-tooltip.component';

@NgModule({
    imports: [
        CommonModule,
        ModalModule,
    ],
    declarations: [
        MobileTooltipComponent,
    ],
    providers: [],
    exports: [
        MobileTooltipComponent,
    ],
    entryComponents: [MobileTooltipComponent]
})
export class MobileTooltipModule {}
